import AxiosClient from '../../../shared/infrastructure/services/axios.client';
import { authService } from '../../users/services/dependency.injection';
import MerchantService from './merchant.service';

const client = new AxiosClient();
const merchantService = new MerchantService(authService, client);

export { merchantService };
